/**
 * Scroll-reveal — fade-in + 8px rise on section entry.
 * Once only, ~450ms ease-out, 80ms stagger between children.
 * Respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const THRESHOLD = 0.12;
  const STAGGER_MS = 80;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const children = el.querySelectorAll('[data-reveal-child]');
        if (children.length > 0) {
          children.forEach((child, i) => {
            child.style.setProperty('--reveal-delay', `${i * STAGGER_MS}ms`);
            child.classList.add('reveal-visible');
          });
        }
        el.classList.add('reveal-visible');
        observer.unobserve(el);
      });
    },
    { threshold: THRESHOLD }
  );

  function init() {
    document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
